"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailingApi = exports.MailingApiFactory = exports.MailingApiFp = exports.MailingApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * MailingApi - axios parameter creator
 * @export
 */
const MailingApiAxiosParamCreator = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateMailingListEntryDto} createMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToMailingList: (id, createMailingListEntry, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling addToMailingList.');
            }
            // verify required parameter 'createMailingListEntry' is not null or undefined
            if (createMailingListEntry === null || createMailingListEntry === undefined) {
                throw new base_1.RequiredError('createMailingListEntry', 'Required parameter createMailingListEntry was null or undefined when calling addToMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}/add`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createMailingListEntry !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createMailingListEntry !== undefined ? createMailingListEntry : {})
                : (createMailingListEntry || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptIn: (optInOutConfirmationBody, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'optInOutConfirmationBody' is not null or undefined
            if (optInOutConfirmationBody === null || optInOutConfirmationBody === undefined) {
                throw new base_1.RequiredError('optInOutConfirmationBody', 'Required parameter optInOutConfirmationBody was null or undefined when calling confirmMailingOptIn.');
            }
            const localVarPath = `/mailing/opt-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof optInOutConfirmationBody !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(optInOutConfirmationBody !== undefined ? optInOutConfirmationBody : {})
                : (optInOutConfirmationBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptOut: (optInOutConfirmationBody, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'optInOutConfirmationBody' is not null or undefined
            if (optInOutConfirmationBody === null || optInOutConfirmationBody === undefined) {
                throw new base_1.RequiredError('optInOutConfirmationBody', 'Required parameter optInOutConfirmationBody was null or undefined when calling confirmMailingOptOut.');
            }
            const localVarPath = `/mailing/opt-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof optInOutConfirmationBody !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(optInOutConfirmationBody !== undefined ? optInOutConfirmationBody : {})
                : (optInOutConfirmationBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMailingChannelDto} createMailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingChannel: (createMailingChannel, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMailingChannel' is not null or undefined
            if (createMailingChannel === null || createMailingChannel === undefined) {
                throw new base_1.RequiredError('createMailingChannel', 'Required parameter createMailingChannel was null or undefined when calling createMailingChannel.');
            }
            const localVarPath = `/mailing/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createMailingChannel !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createMailingChannel !== undefined ? createMailingChannel : {})
                : (createMailingChannel || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingDeliverable: (mailingDeliverable, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mailingDeliverable' is not null or undefined
            if (mailingDeliverable === null || mailingDeliverable === undefined) {
                throw new base_1.RequiredError('mailingDeliverable', 'Required parameter mailingDeliverable was null or undefined when calling createMailingDeliverable.');
            }
            const localVarPath = `/mailing/deliverables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingDeliverable !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingDeliverable !== undefined ? mailingDeliverable : {})
                : (mailingDeliverable || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMailingListDto} createMailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingList: (createMailingList, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMailingList' is not null or undefined
            if (createMailingList === null || createMailingList === undefined) {
                throw new base_1.RequiredError('createMailingList', 'Required parameter createMailingList was null or undefined when calling createMailingList.');
            }
            const localVarPath = `/mailing/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createMailingList !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createMailingList !== undefined ? createMailingList : {})
                : (createMailingList || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingChannel: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteMailingChannel.');
            }
            const localVarPath = `/mailing/channels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingDeliverable: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteMailingDeliverable.');
            }
            const localVarPath = `/mailing/deliverables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingList: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingChannels: (ids, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new base_1.RequiredError('ids', 'Required parameter ids was null or undefined when calling deleteManyMailingChannels.');
            }
            const localVarPath = `/mailing/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingDeliverables: (ids, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new base_1.RequiredError('ids', 'Required parameter ids was null or undefined when calling deleteManyMailingDeliverables.');
            }
            const localVarPath = `/mailing/deliverables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingLists: (ids, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new base_1.RequiredError('ids', 'Required parameter ids was null or undefined when calling deleteManyMailingLists.');
            }
            const localVarPath = `/mailing/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannel: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getMailingChannel.');
            }
            const localVarPath = `/mailing/channels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannels: (page, size, translate, sort, search, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannelsCount: (page, size, sort, search, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/channels/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverable: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getMailingDeliverable.');
            }
            const localVarPath = `/mailing/deliverables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverables: (page, size, translate, sort, search, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/deliverables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverablesCount: (page, size, sort, search, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/deliverables/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingList: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingLists: (page, size, translate, sort, search, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingListsCount: (page, size, sort, search, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/mailing/lists/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a very performant method for checking if a MailingChannel exists.
         * @summary Check if MailingChannel exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingChannelExists: (id, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling mailingChannelExists.');
            }
            const localVarPath = `/mailing/channels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a very performant method for checking if a MailingDeliverable exists.
         * @summary Check if MailingDeliverable exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingDeliverableExists: (id, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling mailingDeliverableExists.');
            }
            const localVarPath = `/mailing/deliverables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a very performant method for checking if a MailingList exists.
         * @summary Check if MailingList exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingListExists: (id, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling mailingListExists.');
            }
            const localVarPath = `/mailing/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {any} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingChannel: (id, mailingChannel, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchMailingChannel.');
            }
            // verify required parameter 'mailingChannel' is not null or undefined
            if (mailingChannel === null || mailingChannel === undefined) {
                throw new base_1.RequiredError('mailingChannel', 'Required parameter mailingChannel was null or undefined when calling patchMailingChannel.');
            }
            const localVarPath = `/mailing/channels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingChannel !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingChannel !== undefined ? mailingChannel : {})
                : (mailingChannel || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {any} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingDeliverable: (id, mailingDeliverable, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchMailingDeliverable.');
            }
            // verify required parameter 'mailingDeliverable' is not null or undefined
            if (mailingDeliverable === null || mailingDeliverable === undefined) {
                throw new base_1.RequiredError('mailingDeliverable', 'Required parameter mailingDeliverable was null or undefined when calling patchMailingDeliverable.');
            }
            const localVarPath = `/mailing/deliverables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingDeliverable !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingDeliverable !== undefined ? mailingDeliverable : {})
                : (mailingDeliverable || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {any} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingList: (id, mailingList, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchMailingList.');
            }
            // verify required parameter 'mailingList' is not null or undefined
            if (mailingList === null || mailingList === undefined) {
                throw new base_1.RequiredError('mailingList', 'Required parameter mailingList was null or undefined when calling patchMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingList !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingList !== undefined ? mailingList : {})
                : (mailingList || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {MailingChannelDto} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingChannel: (id, mailingChannel, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putMailingChannel.');
            }
            // verify required parameter 'mailingChannel' is not null or undefined
            if (mailingChannel === null || mailingChannel === undefined) {
                throw new base_1.RequiredError('mailingChannel', 'Required parameter mailingChannel was null or undefined when calling putMailingChannel.');
            }
            const localVarPath = `/mailing/channels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingChannel !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingChannel !== undefined ? mailingChannel : {})
                : (mailingChannel || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingDeliverable: (id, mailingDeliverable, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putMailingDeliverable.');
            }
            // verify required parameter 'mailingDeliverable' is not null or undefined
            if (mailingDeliverable === null || mailingDeliverable === undefined) {
                throw new base_1.RequiredError('mailingDeliverable', 'Required parameter mailingDeliverable was null or undefined when calling putMailingDeliverable.');
            }
            const localVarPath = `/mailing/deliverables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingDeliverable !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingDeliverable !== undefined ? mailingDeliverable : {})
                : (mailingDeliverable || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {MailingListDto} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingList: (id, mailingList, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putMailingList.');
            }
            // verify required parameter 'mailingList' is not null or undefined
            if (mailingList === null || mailingList === undefined) {
                throw new base_1.RequiredError('mailingList', 'Required parameter mailingList was null or undefined when calling putMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof mailingList !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(mailingList !== undefined ? mailingList : {})
                : (mailingList || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {RemoveMailingListEntryDto} removeMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingList: (id, removeMailingListEntry, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling removeFromMailingList.');
            }
            // verify required parameter 'removeMailingListEntry' is not null or undefined
            if (removeMailingListEntry === null || removeMailingListEntry === undefined) {
                throw new base_1.RequiredError('removeMailingListEntry', 'Required parameter removeMailingListEntry was null or undefined when calling removeFromMailingList.');
            }
            const localVarPath = `/mailing/lists/{id}/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof removeMailingListEntry !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(removeMailingListEntry !== undefined ? removeMailingListEntry : {})
                : (removeMailingListEntry || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingListConfirmation: (id, token, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling removeFromMailingListConfirmation.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling removeFromMailingListConfirmation.');
            }
            const localVarPath = `/mailing/lists/{id}/confirm/{token}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {SendMailingListContentDto} sendMailingListContent
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailingContent: (id, sendMailingListContent, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling sendMailingContent.');
            }
            // verify required parameter 'sendMailingListContent' is not null or undefined
            if (sendMailingListContent === null || sendMailingListContent === undefined) {
                throw new base_1.RequiredError('sendMailingListContent', 'Required parameter sendMailingListContent was null or undefined when calling sendMailingContent.');
            }
            const localVarPath = `/mailing/lists/{id}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof sendMailingListContent !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(sendMailingListContent !== undefined ? sendMailingListContent : {})
                : (sendMailingListContent || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MailingApiAxiosParamCreator = MailingApiAxiosParamCreator;
/**
 * MailingApi - functional programming interface
 * @export
 */
const MailingApiFp = function (axiosClientConfiguration) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateMailingListEntryDto} createMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToMailingList(id, createMailingListEntry, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).addToMailingList(id, createMailingListEntry, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptIn(optInOutConfirmationBody, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).confirmMailingOptIn(optInOutConfirmationBody, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptOut(optInOutConfirmationBody, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).confirmMailingOptOut(optInOutConfirmationBody, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateMailingChannelDto} createMailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingChannel(createMailingChannel, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).createMailingChannel(createMailingChannel, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingDeliverable(mailingDeliverable, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).createMailingDeliverable(mailingDeliverable, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateMailingListDto} createMailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingList(createMailingList, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).createMailingList(createMailingList, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingChannel(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteMailingChannel(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingDeliverable(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteMailingDeliverable(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingList(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteMailingList(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingChannels(ids, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteManyMailingChannels(ids, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingDeliverables(ids, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteManyMailingDeliverables(ids, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingLists(ids, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).deleteManyMailingLists(ids, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannel(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingChannel(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannels(page, size, translate, sort, search, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingChannels(page, size, translate, sort, search, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannelsCount(page, size, sort, search, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingChannelsCount(page, size, sort, search, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverable(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingDeliverable(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverables(page, size, translate, sort, search, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingDeliverables(page, size, translate, sort, search, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverablesCount(page, size, sort, search, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingDeliverablesCount(page, size, sort, search, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingList(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingList(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingLists(page, size, translate, sort, search, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingLists(page, size, translate, sort, search, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingListsCount(page, size, sort, search, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).getMailingListsCount(page, size, sort, search, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * This is a very performant method for checking if a MailingChannel exists.
         * @summary Check if MailingChannel exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingChannelExists(id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).mailingChannelExists(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * This is a very performant method for checking if a MailingDeliverable exists.
         * @summary Check if MailingDeliverable exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingDeliverableExists(id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).mailingDeliverableExists(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * This is a very performant method for checking if a MailingList exists.
         * @summary Check if MailingList exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingListExists(id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).mailingListExists(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingChannel(id, mailingChannel, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).patchMailingChannel(id, mailingChannel, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingDeliverable(id, mailingDeliverable, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).patchMailingDeliverable(id, mailingDeliverable, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingList(id, mailingList, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).patchMailingList(id, mailingList, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {MailingChannelDto} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingChannel(id, mailingChannel, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).putMailingChannel(id, mailingChannel, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingDeliverable(id, mailingDeliverable, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).putMailingDeliverable(id, mailingDeliverable, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {MailingListDto} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingList(id, mailingList, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).putMailingList(id, mailingList, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {RemoveMailingListEntryDto} removeMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingList(id, removeMailingListEntry, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).removeFromMailingList(id, removeMailingListEntry, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingListConfirmation(id, token, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).removeFromMailingListConfirmation(id, token, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {SendMailingListContentDto} sendMailingListContent
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailingContent(id, sendMailingListContent, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.MailingApiAxiosParamCreator)(axiosClientConfiguration).sendMailingContent(id, sendMailingListContent, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.MailingApiFp = MailingApiFp;
/**
 * MailingApi - factory interface
 * @export
 */
const MailingApiFactory = function (axiosClientConfiguration, basePath, axios) {
    return {
        /**
         *
         * @param {string} id
         * @param {CreateMailingListEntryDto} createMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToMailingList(id, createMailingListEntry, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).addToMailingList(id, createMailingListEntry, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptIn(optInOutConfirmationBody, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).confirmMailingOptIn(optInOutConfirmationBody, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OptInOutConfirmationBodyDto} optInOutConfirmationBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMailingOptOut(optInOutConfirmationBody, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).confirmMailingOptOut(optInOutConfirmationBody, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMailingChannelDto} createMailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingChannel(createMailingChannel, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).createMailingChannel(createMailingChannel, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingDeliverable(mailingDeliverable, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).createMailingDeliverable(mailingDeliverable, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMailingListDto} createMailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailingList(createMailingList, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).createMailingList(createMailingList, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingChannel(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteMailingChannel(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingDeliverable(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteMailingDeliverable(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMailingList(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteMailingList(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingChannels(ids, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteManyMailingChannels(ids, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingDeliverables(ids, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteManyMailingDeliverables(ids, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyMailingLists(ids, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).deleteManyMailingLists(ids, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannel(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingChannel(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannels(page, size, translate, sort, search, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingChannels(page, size, translate, sort, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingChannelsCount(page, size, sort, search, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingChannelsCount(page, size, sort, search, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverable(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingDeliverable(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverables(page, size, translate, sort, search, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingDeliverables(page, size, translate, sort, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingDeliverablesCount(page, size, sort, search, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingDeliverablesCount(page, size, sort, search, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingList(id, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingList(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingLists(page, size, translate, sort, search, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingLists(page, size, translate, sort, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailingListsCount(page, size, sort, search, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).getMailingListsCount(page, size, sort, search, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a very performant method for checking if a MailingChannel exists.
         * @summary Check if MailingChannel exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingChannelExists(id, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).mailingChannelExists(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a very performant method for checking if a MailingDeliverable exists.
         * @summary Check if MailingDeliverable exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingDeliverableExists(id, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).mailingDeliverableExists(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a very performant method for checking if a MailingList exists.
         * @summary Check if MailingList exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailingListExists(id, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).mailingListExists(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingChannel(id, mailingChannel, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).patchMailingChannel(id, mailingChannel, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingDeliverable(id, mailingDeliverable, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).patchMailingDeliverable(id, mailingDeliverable, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {any} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMailingList(id, mailingList, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).patchMailingList(id, mailingList, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {MailingChannelDto} mailingChannel
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingChannel(id, mailingChannel, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).putMailingChannel(id, mailingChannel, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {MailingDeliverableDto} mailingDeliverable
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingDeliverable(id, mailingDeliverable, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).putMailingDeliverable(id, mailingDeliverable, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {MailingListDto} mailingList
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMailingList(id, mailingList, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).putMailingList(id, mailingList, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {RemoveMailingListEntryDto} removeMailingListEntry
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingList(id, removeMailingListEntry, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).removeFromMailingList(id, removeMailingListEntry, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromMailingListConfirmation(id, token, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).removeFromMailingListConfirmation(id, token, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {SendMailingListContentDto} sendMailingListContent
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMailingContent(id, sendMailingListContent, translate, options) {
            return (0, exports.MailingApiFp)(axiosClientConfiguration).sendMailingContent(id, sendMailingListContent, translate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MailingApiFactory = MailingApiFactory;
/**
 * MailingApi - object-oriented interface
 * @export
 * @class MailingApi
 * @extends {BaseAPI}
 */
class MailingApi extends base_1.BaseAPI {
    /**
     *
     * @param {MailingApiAddToMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    addToMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).addToMailingList(requestParameters.id, requestParameters.createMailingListEntry, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiConfirmMailingOptInRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    confirmMailingOptIn(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).confirmMailingOptIn(requestParameters.optInOutConfirmationBody, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiConfirmMailingOptOutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    confirmMailingOptOut(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).confirmMailingOptOut(requestParameters.optInOutConfirmationBody, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiCreateMailingChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    createMailingChannel(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).createMailingChannel(requestParameters.createMailingChannel, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiCreateMailingDeliverableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    createMailingDeliverable(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).createMailingDeliverable(requestParameters.mailingDeliverable, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiCreateMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    createMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).createMailingList(requestParameters.createMailingList, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteMailingChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteMailingChannel(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteMailingChannel(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteMailingDeliverableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteMailingDeliverable(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteMailingDeliverable(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteMailingList(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteManyMailingChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteManyMailingChannels(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteManyMailingChannels(requestParameters.ids, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteManyMailingDeliverablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteManyMailingDeliverables(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteManyMailingDeliverables(requestParameters.ids, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiDeleteManyMailingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    deleteManyMailingLists(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).deleteManyMailingLists(requestParameters.ids, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingChannel(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingChannel(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingChannels(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingChannels(requestParameters.page, requestParameters.size, requestParameters.translate, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingChannelsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingChannelsCount(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingChannelsCount(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.search, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingDeliverableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingDeliverable(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingDeliverable(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingDeliverablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingDeliverables(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingDeliverables(requestParameters.page, requestParameters.size, requestParameters.translate, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingDeliverablesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingDeliverablesCount(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingDeliverablesCount(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.search, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingList(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingLists(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingLists(requestParameters.page, requestParameters.size, requestParameters.translate, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiGetMailingListsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    getMailingListsCount(requestParameters = {}, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).getMailingListsCount(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.search, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a very performant method for checking if a MailingChannel exists.
     * @summary Check if MailingChannel exists
     * @param {MailingApiMailingChannelExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    mailingChannelExists(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).mailingChannelExists(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a very performant method for checking if a MailingDeliverable exists.
     * @summary Check if MailingDeliverable exists
     * @param {MailingApiMailingDeliverableExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    mailingDeliverableExists(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).mailingDeliverableExists(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a very performant method for checking if a MailingList exists.
     * @summary Check if MailingList exists
     * @param {MailingApiMailingListExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    mailingListExists(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).mailingListExists(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPatchMailingChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    patchMailingChannel(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).patchMailingChannel(requestParameters.id, requestParameters.mailingChannel, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPatchMailingDeliverableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    patchMailingDeliverable(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).patchMailingDeliverable(requestParameters.id, requestParameters.mailingDeliverable, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPatchMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    patchMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).patchMailingList(requestParameters.id, requestParameters.mailingList, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPutMailingChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    putMailingChannel(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).putMailingChannel(requestParameters.id, requestParameters.mailingChannel, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPutMailingDeliverableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    putMailingDeliverable(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).putMailingDeliverable(requestParameters.id, requestParameters.mailingDeliverable, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiPutMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    putMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).putMailingList(requestParameters.id, requestParameters.mailingList, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiRemoveFromMailingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    removeFromMailingList(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).removeFromMailingList(requestParameters.id, requestParameters.removeMailingListEntry, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiRemoveFromMailingListConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    removeFromMailingListConfirmation(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).removeFromMailingListConfirmation(requestParameters.id, requestParameters.token, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MailingApiSendMailingContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailingApi
     */
    sendMailingContent(requestParameters, options) {
        return (0, exports.MailingApiFp)(this.axiosClientConfiguration).sendMailingContent(requestParameters.id, requestParameters.sendMailingListContent, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MailingApi = MailingApi;
